import React from "react";
import Modal from "react-bootstrap/Modal";
import PropTypes from "prop-types";
import _Button from "../../../generic/_Button"
import _Input from "../../../generic/_Input";
import { GrTest } from "react-icons/gr";
const _Modal = (props) => {
  const {
    visible,
    onClose,
    title,
    onAction,
    onHandlePhone,
    defaultData,
    isLoading,
    isError,
    errorMsg
  } = props;
  return (
    <Modal show={visible} onHide={onClose} size="lg" centered>
      <Modal.Header closeButton>
        <div className="text-xl font-semibold text-gray-600 flex items-center gap-2">
          <GrTest size={26} className={"text-blue-600"} />
          {title}
        </div>
      </Modal.Header>
      <Modal.Body>
        <_Input
          name="phone"
          title="Número"
          label="Número"
          required
          value={defaultData}
          onChange={(e) => onHandlePhone(e)}
          isError={isError}
          errors={errorMsg}

        />
      </Modal.Body>
      <Modal.Footer>
        <_Button title="Cerrar" onClick={onClose} style="none" />
        <_Button
          title="Enviar"
          onClick={onAction}
          style="primary"
          isLoading={isLoading}
          disabled={isLoading}
        />
      </Modal.Footer>
    </Modal>
  );
};

_Modal.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string,
  visible: PropTypes.bool,
  onClose: PropTypes.func,
  onAction: PropTypes.func,
  isLoading: PropTypes.bool,
  onHandlePhone: PropTypes.func,
  defaultData: PropTypes.string,
  isError: PropTypes.bool,
  errorMsg: PropTypes.string,
};

export default _Modal;
